import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'app-data-usage-warning',
  templateUrl: './data-usage-warning.component.html',
  styleUrls: ['./data-usage-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataUsageWarningComponent implements OnInit {
  isVisible = true;
  dontShowAgain = false;
  private readonly storageKey = 'hideDataUsageWarning';

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    const hideWarning = sessionStorage.getItem(this.storageKey);
    if (hideWarning === 'true') {
      this.isVisible = false;
      this.dontShowAgain = true;
      this.cdr.markForCheck();
    }
  }

  dismiss(): void {
    if (this.dontShowAgain) {
      sessionStorage.setItem(this.storageKey, 'true');
    }
    this.isVisible = false;
    this.cdr.markForCheck();
  }

  onCheckboxChange(event: CustomEvent): void {
    this.dontShowAgain = event.detail.checked;
  }
}
